import HeroSection from './HeroSection.component';
export default HeroSection;